import { ImageType } from 'utils/types';

import { FeatureSectionProps } from './FeatureSection';

export const parseFeatureSection = (
  section: Queries.ContentfulSection001,
): FeatureSectionProps => {
  const title = section?.metadata?.title ?? '';
  const eyebrow = section.eyebrow ?? '';
  const cards = section?.subsections as Queries.ContentfulSection001[];

  return {
    title,
    eyebrow,
    cards:
      cards?.map((card) => ({
        image: card?.images?.[0]?.desktopImage as ImageType,
        description: card?.metadata?.description?.description ?? '',
      })) ?? [],
  };
};
